import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '亚洲国产高清影视内容精选平台',
  url: 'https://loforce.cn',
  description:
    '亚洲国产高清是您发现优质亚洲本土影视内容的最佳入口，汇聚亚洲各地国产高清剧集、电影与综艺，画质清晰、资源丰富。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://loforce.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '亚洲国产高清影视内容精选平台',
  url: 'https://loforce.cn',
  description:
    '亚洲国产高清是专注于亚洲本土高清影视内容的精选推荐平台，提供剧集、电影、综艺、动漫、纪录片等多元化内容。',
  sameAs: ['https://weibo.com/asiadvod', 'https://space.bilibili.com/asiadvod'],
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '亚洲国产高清平台提供哪些类型的影视内容？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '我们平台涵盖国产剧集、高清电影、热门综艺、动漫动画、纪录片、短剧微剧等六大类别的亚洲国产高清影视内容。',
      },
    },
    {
      '@type': 'Question',
      name: '平台上的影视内容可以免费观看吗？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '亚洲国产高清是一个影视内容精选推荐平台，我们提供专业的影视资讯、深度评测和观看指南。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="亚洲国产高清影视内容精选平台 - 发现优质亚洲本土影视内容"
        description="亚洲国产高清是您发现优质亚洲本土影视内容的最佳入口，汇聚亚洲各地国产高清剧集、电影与综艺，画质清晰、资源丰富，满足您对亚洲国产高清内容的全方位需求。"
        keywords="亚洲国产高清,亚洲国产高清剧集,亚洲国产高清电影,亚洲高清影视资源,国产高清综艺,亚洲高清在线观看,国产高清画质影视"
        canonicalUrl="https://loforce.cn"
        ogImage="https://readdy.ai/api/search-image?query=Asian%20film%20and%20television%20platform%20brand%20image%2C%20cinematic%20golden%20and%20crimson%20gradient%2C%20elegant%20oriental%20design%2C%20film%20reel%20elements%2C%20clean%20luxury%20aesthetic&width=1200&height=630&seq=home-og&orientation=landscape"
        schema={[orgSchema, homeSchema, faqSchema]}
      />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <FAQSection />
      </main>
    </>
  );
}